var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { spacing, color, typography } from '../../constants';
import { ErrorSolid } from '../../icons';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), spacing.default);
var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  margin-bottom: ", ";\n  color: ", ";\n  ", "\n  user-select: none;\n"], ["\n  display: block;\n  margin-bottom: ", ";\n  color: ", ";\n  ", "\n  user-select: none;\n"])), spacing.extraTight, color.theme.typography.ink, typography.label);
var HelpText = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", ";\n  color: ", ";\n  ", "\n"], ["\n  margin-top: ", ";\n  color: ", ";\n  ", "\n"])), spacing.extraTight, color.theme.typography.subdued, typography.inputHelp);
var ErrorText = styled(HelpText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), color.theme.input.error.foreground);
var ErrorIcon = styled(ErrorSolid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  fill: ", ";\n  margin-right: ", ";\n"], ["\n  fill: ", ";\n  margin-right: ", ";\n"
    /**
     * Props available to all instances and children of `<Field />` component.
     * Child components should `extend` this.
     */
])), color.theme.input.error.foreground, spacing.extraTight);
/**
 * A `Field` component is used to construct control elements that are part of a form. It is currently
 * recommended that one of the explicit `Field*` components are used over the base `Field` component.
 * FieldText only supports a limited set of values for the `type` prop.
 * The `thick` and `thin` size variants for `FieldTextarea` only apply a minimum height when a value for `rows` is not provided.
 */
export var Field = function (props) {
    var name = props.name, required = props.required, label = props.label, error = props.error, help = props.help, children = props.children, className = props.className;
    return (React.createElement(Container, { className: className },
        React.createElement(Label, { htmlFor: name },
            Boolean(required) && '*',
            label),
        children({
            error: error !== undefined && error !== false,
            name: name,
            id: name
        }),
        error !== undefined && error !== false && (React.createElement(ErrorText, null,
            React.createElement(ErrorIcon, { tiny: true }),
            error)),
        help !== undefined && !(error !== undefined) && (React.createElement(HelpText, null, help))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map